import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getPresentationEditorPathByPublicPath } from "../../../presentationHubRoutes";

export const AdminLink = ({ className }) => {
  const location = useLocation();
  const editorPath = getPresentationEditorPathByPublicPath(location.pathname);

  return (
    <Link
      to={editorPath}
      data-testid="admin-link"
      aria-label="Open Presentation Hub editor"
      title="Open Presentation Hub editor"
      className={`${className !== undefined ? className : "fixed top-6 right-6"} z-[100] group pointer-events-auto`}
      style={{ position: className !== undefined ? 'relative' : 'fixed', zIndex: 9999, pointerEvents: 'auto' }}
    >
      <span className="glass bg-black/60 border border-white/10 rounded-full w-10 h-10 flex items-center justify-center transition-all hover:border-[var(--ph-accent)] hover:bg-[var(--ph-accent-glow)] shadow-xl">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-neutral-400 group-hover:text-[var(--ph-accent)] transition-colors"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      </span>
    </Link>
  );
};

